import * as $ from "jquery";
import colorbox = require("../lib/plaudit.colorbox.js");
if (colorbox === undefined) {
	console.log("This is impossible - I just added this to ensure that no imports get dropped!");
}

import siteLightboxOptions = require("./siteLightboxOptions.js");

function capitalizeFirstLetter(string?: string): string|undefined {
	if (string === undefined) return;
	const firstLetter = string[0] || string.charAt(0);
	return firstLetter ? firstLetter.toUpperCase() + string.slice(1) : '';
}
function findClosestParentByName(elem: Element, parentName: string) {
	let node = elem.parentNode;
	for (; node !== null; node = node.parentNode) {
		if (node.nodeName.toLowerCase() === parentName) {
			return node as Element;
		}
	}
	return null;
}

type ConfigType = {
	url: string,
	addActionId: string,
	removeActionId: string,
	attributes: {[key: string]: string},
	handlers: {[key: string]: (event: MouseEvent) => any}
};
type extractor<Type> = Type extends Array<infer T> ? T : Type;
type CallbackType = extractor<Parameters<ReturnType<typeof $["ajax"]>["done"]>[0]>;

// Sending flag - set during AJAX request
let sending = false;
function sendRequest(config: ConfigType, data: {[key: string]: any}, callback: CallbackType, elem?: Element) {
	sending = true;
	$.ajax(config.url, {
		data: data,
	}).done(function (response, a, b) {
		callback(response, a, b);
		document.dispatchEvent(new Event('bookmarkingComplete'));
	}).fail(function (err) {
		if (err.status === 403) {
			const options = $.extend({}, siteLightboxOptions.options(), {
				html: function () {
					return siteLightboxOptions.load('login.html?mode=lightbox');
				},
				onComplete: function () {
					document.addEventListener('loginSuccess', function () {
						($ as any).colorbox.close();
						location.reload();
					});
				}
			});
			($ as any).colorbox(options);
		} else {
			if (err.responseJSON.errorType === "bookmark-not-found") {
				// Remove bookmark when clicked if not found.
				setBookmarkId(config, elem, "");
				setAction(config, elem, config.addActionId);
			} else {
				console.error(err);
			}
		}
	}).always(function () {
		sending = false;
	});
}
function setBookmarkId(config: ConfigType, elem: Element, id: string) {
	elem.setAttribute(config.attributes.bookmarkId, id);
}
function setAction(config: ConfigType, elem: Element, action: string) {
	elem.setAttribute(config.attributes.action, action);
	elem.setAttribute('title', capitalizeFirstLetter(action));
}

export default function init() {
	// Configs
	const config = {
		url: "bookmark",
		addActionId: "add",
		removeActionId: "remove",
		attributes: {
			action: "data-action",
			attachedAction: "data-attached-action",
			bookmarkId: "data-bookmark-id",
			practiceId: "data-practice-id",
			removeListing: "data-remove-listing",
			userType: "data-user-type"
		},
		handlers: {
			"add": (event: MouseEvent) => {
				let elem = event.currentTarget as HTMLElement;
				if (!elem.hasAttribute(config.attributes.userType) && !elem.hasAttribute(config.attributes.practiceId)) {
					elem = event.target as HTMLElement;
				}

				const listener = function () {
					elem.blur();
					document.head.focus();
					document.removeEventListener('bookmarkingComplete', listener);
				};
				document.addEventListener('bookmarkingComplete', listener);

				if (elem.getAttribute(config.attributes.userType) === "buyer") {
					// Data attributes
					const action = elem.getAttribute(config.attributes.action);
					const bookmarkId = elem.getAttribute(config.attributes.bookmarkId);
					const practiceId = elem.getAttribute(config.attributes.practiceId);
					const removeListing = elem.getAttribute(config.attributes.removeListing) === "true";

					const step2Options = $.extend({}, siteLightboxOptions.options('bookmarkPopup'), {
						html: function () {
							return '<form class="bookmarkPopup__inner">' +
								'<div class="fieldArea htmlTextarea">' +
								'<label for="bookmarkPopup__reason">Please provide us with a brief outline of your M&amp;A strategy so we can best match your interest with this opportunity as well as future listings (max: 1000 characters).</label>' +
								'<textarea name="bookmarkPopup__reason" id="bookmarkPopup__reason" class="bookmarkPopup__reason" maxlength="1000"></textarea>' +
								'</div>' +
								'<span class="bookmarkPopup__btn btn submit">' +
								'<button\n' +
								'\t\t\t\t\tclass="bookmark-practice"\n' +
								'\t\t\t\t\tdata-action="' + action + '"\n' +
								'\t\t\t\t\tdata-remove-listing="' + removeListing + '"\n' +
								'\t\t\t\t\tdata-bookmark-id="' + bookmarkId + '"\n' +
								'\t\t\t\t\tdata-practice-id="' + practiceId + '"\n' +
								'\t\t\t\t\ttype="button"\n' +
								'\t\t\t\t>Bookmark</button></span></form>';
						},
						onComplete: () => {
							document.querySelectorAll(`.bookmark-practice:not([${config.attributes.attachedAction}])`)
								.forEach(ele => attachOrReattachAction(ele));
							const listener = function () {
								($ as any).colorbox.close();
								document.removeEventListener('bookmarkingComplete', listener);
							};
							document.addEventListener('bookmarkingComplete', listener);
						}
					});

					const step1Options = $.extend({}, siteLightboxOptions.options('bookmarkPopup'), {
						html: function () {
							return '<div class="bookmarkPopup__inner">' +
								'<p>Thank you for your indication of interest. Our team will be compiling an interested buyer list over the next couple weeks.</p>' +
								'<p>Only buyers who have been verified are eligible to proceed through the buyer diligence process for a selling practice. In the event you have not been verified, please visit the "Verification" tab within your buyer account and upload requisite verification documentation.</p>' +
								'<p><a href="https://www.youtube.com/watch?v=IgOO--8Iixc" target="_blank">Click here to watch a walk-through of the APBOE Verification Process.</a></p>' +
								'<p>Please contact us at <a href="mailto:info@apboe.com">info@apboe.com</a> with any questions.</p>' +
								'<button class="bookmarkPopup__next btn"><span>Next</span></button>' +
								'</div>';
						},
						onOpen: function () {
							$(document).on("click", ".bookmarkPopup__next", function () {
								($ as any).colorbox(step2Options);
								$(document).off("click", ".bookmarkPopup__next");
							});
						}
					});
					($ as any).colorbox(step1Options);
				} else {
					const practiceId = elem.getAttribute(config.attributes.practiceId);
					if (practiceId) {
						// Send request to listings/bookmarks?practiceId=[ID] to add bookmark
						const form = findClosestParentByName(elem, 'form');

						sendRequest(config, {
								"practiceId": practiceId,
								"reason": form?.querySelector<HTMLInputElement>("textarea.bookmarkPopup__reason")?.value || 'None'
							},
							function (response) {
								let practiceIdSelector = '[' + config.attributes.practiceId + '="' + practiceId + '"]';
								document.querySelectorAll(practiceIdSelector).forEach((element) => {
									setBookmarkId(config, element, response.bookmarkId);
									setAction(config, element, config.removeActionId);
									const evt = new Event('bookmarkStateChange');
									(evt as any).practiceId = practiceId;
									document.dispatchEvent(evt);
								});


								/* switch from not bookmarked to bookmarked call-to-action */
								$(elem).parents(".practiceDetails__callout").find(".practiceDetails__calloutInner")
									.attr('hidden', function (index, attr) {
										return `${!attr}`;
									});
						});
					}
				}
			},
			"remove": (event: MouseEvent) => {
				let elem = event.currentTarget as HTMLElement;
				if (!elem.hasAttribute(config.attributes.bookmarkId)) {
					elem = event.target as HTMLElement;
				}

				const possibleElements: HTMLElement[] = [elem];
				const listener = function () {
					function blurAll(element: Node) {
						if (element instanceof HTMLElement) {
							console.log(element.nodeName, element.className);
							element.blur();
						}
						element.childNodes?.forEach(blurAll);
					}
					possibleElements.forEach(pe => blurAll(pe));
					blurAll(elem);
					// document.head.focus();
					document.removeEventListener('bookmarkingComplete', listener);
				};
				document.addEventListener('bookmarkingComplete', listener);

				let bookmarkId = elem.getAttribute(config.attributes.bookmarkId);
				while (bookmarkId === null) {
					elem = elem.parentElement;
					if (elem === null) {
						return;
					}
					possibleElements.push(elem);
					bookmarkId = elem.getAttribute(config.attributes.bookmarkId);
				}
				if (bookmarkId) {
					const practiceId = elem.getAttribute(config.attributes.practiceId);
					const removeListing = elem.getAttribute(config.attributes.removeListing) === "true";
					// Send request to listings/bookmarks?bookmarkId=[ID] to remove bookmark
					sendRequest(config, { "bookmarkId": bookmarkId }, function () {
						// Fade out and remove parent listing if set
						if (removeListing) {
							$(elem).parents(".practiceListing__item").fadeOut(300, function () {
								$(this).remove();
							});
						}

						const bookmarkIdSelector = `[${config.attributes.bookmarkId}="${bookmarkId}"]`;
						document.querySelectorAll(bookmarkIdSelector).forEach((element) => {
							setBookmarkId(config, element, "");
							setAction(config, element, config.addActionId);
							const evt = new Event('bookmarkStateChange');
							(evt as any).practiceId = practiceId;
							document.dispatchEvent(evt);
						});
					}, elem);
				}
			}
		}
	};

	const attachOrReattachAction = (element: Element) => {
		const previouslyAttachedAction = element.getAttribute(config.attributes.attachedAction);
		if (previouslyAttachedAction !== null && previouslyAttachedAction !== undefined) {
			element.removeEventListener("click", config.handlers[previouslyAttachedAction as keyof typeof config["handlers"]]);
			if (previouslyAttachedAction === element.getAttribute(config.attributes.action)) {
				element.addEventListener("click", config.handlers[previouslyAttachedAction as keyof typeof config["handlers"]]);
			}
		}
		const actionId = element.getAttribute(config.attributes.action);
		if (config.handlers.hasOwnProperty(actionId)) {
			element.addEventListener("click", config.handlers[actionId as keyof typeof config["handlers"]]);
			element.setAttribute(config.attributes.attachedAction, actionId);
		}
	};

	const observer = new MutationObserver(mutations => {
		for (let mutation of mutations) {
			if (mutation.type === "attributes") {
				if (mutation.attributeName === config.attributes.action) {
					attachOrReattachAction(mutation.target as Element);
				}
			} else if (mutation.type === "childList") {
				(mutation.target as Element).querySelectorAll(".bookmark-practice")
					.forEach(element => attachOrReattachAction(element));
			}
		}
	});
	const observerConfig = { attributes: true, childList: true, subtree: true };
	document.addEventListener('registerBookmarkableArea', (event: CustomEvent<Element>) => {
		event.detail.querySelectorAll(".bookmark-practice")
			.forEach(element => attachOrReattachAction(element));
	}, false);

	document.querySelectorAll(".bookmarkPracticeButtonContainer").forEach(element => {
		element.querySelectorAll(".bookmark-practice")
			.forEach(element => attachOrReattachAction(element));
		observer.observe(element, observerConfig);
	});
}
